import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import { useSidebar } from "components/ui/sidebar";
import { LogOut } from "lucide-react";
import { motion } from "framer-motion";
import { OnAuth0Logout } from "functions/auth0Utils";

export default function SidebarLogoutButton({ isTouchDevice = false }) {

    const { open, animate, setOpen } = useSidebar();

    const { logout } = useAuth0()

    const handleClick = () => {
        // If sidebar is open when clicking, persist that state
        if (open) {
            setOpen(true);
        }

        OnAuth0Logout(logout);
    };

    if (isTouchDevice === true) {
        return (
            <Link
                className="flex flex-col items-center justify-center gap-0.5 py-2"
                onClick={handleClick}
            >
                <LogOut className="text-neutral-200 flex-shrink-0 h-8 w-8" />
                
                <p className="text-center text-white text-xxs">Log out</p>
            </Link>
        )
    }
    
    if (isTouchDevice === false) {
        return (
            <Link
                className="flex items-center justify-start gap-2 group/sidebar py-2"
                onClick={handleClick}
            >
                <LogOut className="ml-1 text-neutral-200 flex-shrink-0 h-5 w-5" />

                <motion.span
                    initial={{
                        display: animate ? (open ? "inline-block" : "none") : "inline-block",
                        opacity: animate ? (open ? 1 : 0) : 1,
                    }}
                    animate={{
                        display: animate ? (open ? "inline-block" : "none") : "inline-block",
                        opacity: animate ? (open ? 1 : 0) : 1,
                    }}
                    className="text-neutral-200 text-sm group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0"
                >
                    Log out
                </motion.span>
            </Link>
        )
    }
}